import Api from '@teko/api';

function getIdToken() {
    var _a, _b, _c, _d;
    if (typeof window !== 'undefined') {
        return (_d = (_c = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.TekoID) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.loadUser()) === null || _d === void 0 ? void 0 : _d.idToken;
    }
    return;
}
class LoyaltyService {
    constructor(loyaltyUrl, clientId) {
        this.getLoyaltyMemberInfo = async () => {
            var _a;
            if (!this.clientId) {
                return null;
            }
            const { data } = await this.loyaltyApi.get(`/members/info`);
            return ((_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.member) || {};
        };
        this.getLoyalties = async (txnTypes, status = 4, pageNumber = 0, pageSize = 10) => {
            var _a;
            if (!this.clientId) {
                return { transactions: [], extra: {} };
            }
            const { data } = await this.loyaltyApi.get('/transactions', {
                params: {
                    txn_types: txnTypes,
                    status: status,
                    page: pageNumber,
                    size: pageSize,
                },
            });
            const transactions = ((_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.transactions) || [];
            const extra = (data === null || data === void 0 ? void 0 : data.extra) || {};
            return { transactions, extra };
        };
        this.getNetworkConfig = async () => {
            var _a;
            if (!this.clientId) {
                return null;
            }
            const { data } = await this.loyaltyApi.get('/network-config');
            const networkConfig = ((_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.network_config) || {};
            return {
                loyaltyExchangeRate: networkConfig.exchange_rate,
                loyaltyPointCode: networkConfig.currency_name,
                loyaltyIcon: networkConfig.currency_img,
                avatarDefaultImg: networkConfig.avatar_default_img,
                brandColor: networkConfig.brand_color,
                cardDefaultImg: networkConfig.card_default_img,
                faqUrl: networkConfig.faq_web_url,
            };
        };
        this.getEncryptedMembershipCode = async () => {
            var _a, _b;
            if (!this.clientId)
                return '';
            const { data } = await this.loyaltyApi.get('/members/encrypted-membership-code');
            return (_b = (_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.encrypted_membership_qrdata) === null || _b === void 0 ? void 0 : _b.code;
        };
        this.loyaltyApi = new Api(loyaltyUrl);
        this.clientId = clientId;
        this.loyaltyApi.addInterceptor((request) => {
            if (this.clientId) {
                request.headers.set('X-Client-Id', this.clientId);
            }
            if (typeof window !== 'undefined') {
                request.headers.set('X-Member-Token', getIdToken());
            }
        });
    }
    get networkClientId() {
        return this.clientId;
    }
}

export { LoyaltyService };
